export const STATIONS_DISPLAY_BUTTON_ID = 'stations-show';
